/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { memo } from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { MediaButton } from "components";
import { Tooltip, TooltipProps } from "components/Tooltip";
import ClipboardIcon from "resources/icons/clipboard.svg";

interface IClipboardCopyButtonProps extends WithTranslation {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customIcon?: any;
  className?: string;
  placement?: TooltipProps["placement"];
  onClick?: () => void;
}

export const ClipboardCopyButton = withTranslation()(
  memo(
    ({
      t,
      customIcon,
      className,
      placement,
      onClick,
    }: IClipboardCopyButtonProps) => {
      const _onClick = () => {
        navigator.clipboard.writeText(window.location.href);
      };

      return (
        <Tooltip
          title={t("ASSET_COPY_LINK_TO_CLIPBOARD")}
          placement={placement}
          trigger="click"
        >
          <MediaButton
            variant="transparent"
            className={className}
            icon={customIcon || <ClipboardIcon />}
            iconElevated={true}
            onClick={onClick || _onClick}
            type="button"
            ariaLabel={t("COMMON__BUTTON_COPY_LINK")}
          />
        </Tooltip>
      );
    },
  ),
);
